import axios from 'axios';
import { useMutation, useQueryClient } from 'react-query';

const apiUrl = () => process.env.REACT_APP_BASIX_API || '';

export interface GenerateInvoiceInput {
  workOrderId: string;
  itemize: boolean;
  // optional — blank invoiceNumber auto-numbers (item 101); proposal-driven WOs
  // ignore these and apply item-50 naming/split server-side
  invoiceNumber?: string;
  discount?: number;
  discountReason?: string;
  // item 433 — optional deposit-split override (proposal-driven DEPOSIT invoices only)
  depositPercentOverride?: number | null;
}

// item 38: generate an invoice by converting a work order / sales order. Returns
// the new invoice id so the caller can open the editable draft. The backend
// (InvoiceCreateAction) requires a work order and enforces one invoice per WO.
const useGenerateInvoice = () => {
  const queryClient = useQueryClient();

  const mutation = useMutation(
    async (input: GenerateInvoiceInput): Promise<string> => {
      const { data } = await axios.post(`${apiUrl()}invoice`, input);
      return data as string;
    },
    {
      onSuccess: () => Promise.all([
        queryClient.invalidateQueries('invoices'),
        queryClient.invalidateQueries('workOrders'),
        queryClient.invalidateQueries('proposals'),
      ]),
    },
  );

  return { generate: mutation.mutateAsync, isGenerating: mutation.isLoading };
};

export default useGenerateInvoice;
